import { BasePathProvider, useBasePath } from "components/Providers";
import { useLocation, useParams } from "react-router-dom";
import ArtifactForm from "./ArtifactForm";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { get as getArtifact } from "store/evaluation/admin-artifact";
import { get as getGoal } from "store/evaluation/admin-goal";
import { get as getSelfEvaluation } from "store/evaluation/admin-eval-rating";
import { get as getAdminEvaluation } from "store/evaluation/admin-evaluation";
import GoalForm from "./GoalForm";
import EvaluateForm from "./EvaluateForm";
import EvaluationFormSekeleton from "./FormSkeleton";
import FeedbackForm from "./FeedbackForm";
import AdminEvaluateForm from "./AdminEvaluateForm";
import { ratingGet } from "store/evaluation/admin-evaluation";

const resourceConfig = {
    artifact: { Form: ArtifactForm, getAction: getArtifact, propName: 'artifact', skipFetchValue: "new" },
    goal: { Form: GoalForm, getAction: getGoal, propName: 'goal', skipFetchValue: "new" },
    self: { Form: EvaluateForm, getAction: getSelfEvaluation, propName: 'self', skipFetchValue: "add" },
    feedback: { Form: FeedbackForm, getAction: getAdminEvaluation, propName: 'feedback',},
    admin: { Form: AdminEvaluateForm, getAction: ratingGet, propName: 'adminEvaluation', skipFetchValue: "add" }
};

export default function EvaluationFormIndex() {
    const { resource, id } = useParams();
    const basePath = useBasePath();
    const dispatch = useDispatch();
    const [record, setRecord] = useState(null);

    const config = resourceConfig[resource];
    const Form = config?.Form;
    const getAction = config?.getAction;
    const propName = config?.propName;
    const location = useLocation();
    const action = location.state?.action;
    const evaluationItem = location.state?.item;
    const skipFetchValue = config?.skipFetchValue;

    
    useEffect(() => {
        if (!config) return;

        if (id && id !== skipFetchValue ) {
            dispatch(getAction({ id }))
            .then(res => setRecord(res.payload))
            .catch(() => setRecord(null))    
        }
        else {
            setRecord(null);
        }
    }, [resource, id, dispatch, getAction, config]);

    if ((id !== skipFetchValue && record === null) || !config) {
        return (
            <EvaluationFormSekeleton />
        );
    }

    const props = { 
        [propName]: record,
        ...(resource === 'admin' && evaluationItem !== undefined ? {item: evaluationItem} : {})
    };
    return (
        <BasePathProvider value={basePath}>
            <Form {...props} action={action} />
        </BasePathProvider>
    )


}

